/**
 * @param {import("../shared-types").StudentResponse} studentResponse
 */
export default function omissionCheck(studentResponse) {
    if (studentResponse.gap_match && studentResponse.gap_match.gap_match_matches && studentResponse.gap_match.gap_match_matches.length > 0) {
        return true;
    } else if (studentResponse.inline_choice && studentResponse.inline_choice.inline_choice_matches && studentResponse.inline_choice.inline_choice_matches.length > 0) {
        return true;
    } else if (studentResponse.matching && studentResponse.matching.matching_matches && studentResponse.matching.matching_matches.length > 0) {
        return true;
    } else if (studentResponse.ordering && studentResponse.ordering.ordered_choice_ids && studentResponse.ordering.ordered_choice_ids.length > 0) {
        return true;
    } else if (studentResponse.fill_in_the_blank) {
        return studentResponse.fill_in_the_blank.input_responses.every(function (r) {
            return r.text && r.text.length > 0
        })
    } else if (studentResponse.multiple_bubble && studentResponse.multiple_bubble.choice_ids && studentResponse.multiple_bubble.choice_ids.length > 0) {
        return true;
    } else if(studentResponse.single_bubble) {
        return true;
    } else if(studentResponse.gridded) {
        return studentResponse.gridded.selected_values.some(function (r) {
            return r !== null && r !== undefined
        })
    } else if(studentResponse.drawing) {
        return studentResponse.drawing.image_data || studentResponse.drawing.image_url
    } else if(studentResponse.essay) {
        return studentResponse.essay.response && studentResponse.essay.response.length > 0
    } else if(studentResponse.multipart) {
        return studentResponse.multipart.parts.some(function (r) {
            return omissionCheck(r)
        })
    }
    return false
}